import type { PropsWithChildren } from "react";
import { DefinitionDescription, DefinitionTerm } from "@/components/ui/definition-list.tsx";
import usePowerSupplyDimmingType, {
    CONFIG_CODE_NO,
} from "@/features/sub-families/hooks/use-power-supply-dimming-type.ts";
import { getProductScenario } from "@/features/sub-families/utils/power-supply-dimming-type.ts";
import { useTranslations } from "@/features/translations/components/translations.tsx";
import useCurrentPowerSupply from "@/services/product/hooks/use-current-power-supply.ts";
import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";

export default function PowerSupplyDetails() {
    const t = useTranslations();
    const currentProduct = useCurrentProduct();
    const selectedPowerSupply = useCurrentPowerSupply();
    const powerSupplyDimmingType = usePowerSupplyDimmingType();

    if (!powerSupplyDimmingType) return null;

    const { configCodeYesNo } = powerSupplyDimmingType;
    const productScenario = getProductScenario(currentProduct);

    switch (true) {
        case configCodeYesNo === CONFIG_CODE_NO && productScenario === 2:
        case configCodeYesNo === CONFIG_CODE_NO && productScenario === 3:
            return <SelectedPowerSupply>{t("no")}</SelectedPowerSupply>;

        case selectedPowerSupply !== null:
            return <SelectedPowerSupply>{selectedPowerSupply.product_label}</SelectedPowerSupply>;

        default:
            return null;
    }
}

function SelectedPowerSupply({ children }: PropsWithChildren) {
    const t = useTranslations();

    return (
        <>
            <DefinitionTerm>{t("power_supply")}</DefinitionTerm>
            <DefinitionDescription>{children}</DefinitionDescription>
        </>
    );
}
